import React from "react";
import LineBtn from "../../../../Button/LineBtn";

interface ILoginCheckAllToagleBtn {
  getLoginCheckData: () => void;
  toggleLoginCheck: (subsid: string, nowState: boolean, isApp: boolean) => void;
  loginCheckData: any[];
}

export default function LoginCheckAllToagleBtn({
  getLoginCheckData,
  toggleLoginCheck,
  loginCheckData,
}: ILoginCheckAllToagleBtn) {
  const isAllState = (state: string) => {
    let stateList: boolean[] = [];

    loginCheckData?.forEach((a: any) => {
      const data = a[1];

      if (data?.use && data?.useApp) {
        stateList.push(true);
      } else if (!data?.use && !data?.useApp) {
        stateList.push(false);
      }
    });

    if (state === "ON") {
      const loginCheckSubsCnt = loginCheckData?.length ?? 0;

      if (stateList?.filter((a) => a === true)?.length === loginCheckSubsCnt) {
        return true;
      }
    } else if (state === "OFF") {
      const loginCheckSubsCnt = loginCheckData?.length ?? 0;

      if (stateList?.filter((a) => a === false)?.length === loginCheckSubsCnt) {
        return true;
      }
    }
  };

  const allToagle = (nowState: string) => {
    let allLoginCheckSubsList: string[] = [];

    loginCheckData?.forEach((a: any) => {
      const subsId = a[0];

      allLoginCheckSubsList.push(subsId);
    });

    allLoginCheckSubsList.forEach((a) => {
      toggleLoginCheck(a, nowState === "ON" ? true : false, false);
      toggleLoginCheck(a, nowState === "ON" ? true : false, true);
    });

    getLoginCheckData();
  };

  return (
    <>
      {isAllState("ON") === true || isAllState("OFF") === true ? (
        <LineBtn
          btnText={`전체 ${isAllState("ON") ? "OFF" : "ON"}`}
          btnClickEvent={() => allToagle(isAllState("ON") ? "ON" : "OFF")}
        />
      ) : (
        <></>
      )}
    </>
  );
}
